export default {
  Search: {
    keyWordPlaceholder: 'Search domain name / app name / source IP'
  },
  ListTitle: {
    customer: 'Customer',
    gateWayAndBranch: 'GateWay / Branch',
    srcIp: 'Source IP',
    destDomainIpPort: 'Destination Domain/IP/Port',
    destApp: 'Destination App',
    protocol: 'Protocol',
    upTraffic: 'Upstream Traffic(byte)',
    downTraffic: 'Downstream Traffic(byte)',
    accessTime: 'Access Time',
  }
}